// Central brand + content config. Swap image URLs / hex when official assets arrive.
import { Trophy, Palette, ShoppingBag, GraduationCap, Gamepad2, Radio } from "lucide-react";

export const BRAND = {
  name: "Talanta Hela",
  tagline: "Monetizing Talent, Empowering Kenya",
  logoEmblem:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_hela-entry-one/artifacts/nrbuwqjg_image.png",
  logo: "/logo-knockout.png",
  logoOriginal:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_hela-entry-one/artifacts/nrbuwqjg_image.png",
  heroImage:
    "https://static.prod-images.emergentagent.com/jobs/aacb98c8-ada4-42b5-bc80-99974f37a0d2/images/bde1a3eef1111a64c3f7c4fb35c2a82aa0094ad67e444b8fd709291501efdef9.jpeg",
};

export const STATS = [
  { value: "150,000+", label: "Talents" },
  { value: "6", label: "Pillars" },
  { value: "KES 50M+", label: "Disbursed" },
  { value: "47", label: "Counties" },
];

export const PILLARS = [
  {
    id: "sport",
    name: "Talanta Sport",
    short: "Sport",
    icon: Trophy,
    state: "active",
    blurb: "AI-driven scouting (aiScout), performance analytics, tournaments and athlete profiles powered by the NextGen engine.",
    image:
      "https://images.unsplash.com/photo-1769878621200-ed1431057a3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    externalUrl: "https://sport.talentahela.com",
  },
  {
    id: "digital",
    name: "Talanta Digital",
    short: "Digital",
    icon: Palette,
    state: "soon",
    blurb: "imagineBC social & entertainment platform — a new way for creators and every citizen to earn from content.",
    image:
      "https://images.unsplash.com/photo-1621609764095-b32bbe35cf3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    externalUrl: "",
  },
  {
    id: "soko",
    name: "Talanta Soko",
    short: "Soko",
    icon: ShoppingBag,
    state: "connected",
    blurb: "Sell directly to Kenyans at home and in the diaspora — tournament tickets, merch and collectibles via the NextGen engine.",
    image:
      "https://images.unsplash.com/photo-1787532379136-5e9b52edbc1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    externalUrl: "",
  },
  {
    id: "education",
    name: "Talanta Academy",
    short: "Education",
    icon: GraduationCap,
    state: "soon",
    blurb: "Immersive virtual courses with Grathons and TVETA-accredited institutions, plus scholarship and grant matchmaking.",
    image:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    externalUrl: "",
  },
  {
    id: "gaming",
    name: "Talanta Gaming",
    short: "Gaming",
    icon: Gamepad2,
    state: "soon",
    blurb: "Advancing Kenya's eSports industry with the Esports Federation of Kenya and Kunta Content — leagues, streaming, prize pools.",
    image:
      "https://images.unsplash.com/photo-1632454005865-1ea2afe2074f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    externalUrl: "",
  },
  {
    id: "broadcast",
    name: "Talanta Broadcast",
    short: "Broadcast",
    icon: Radio,
    state: "connected",
    blurb: "Kenyan sport, music, film and TV streamed to global audiences via Arabsat — live NextGen tournaments included.",
    image:
      "https://images.unsplash.com/photo-1682617367276-bbacadf73747?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    externalUrl: "",
  },
];
